<template>
  <div id="creditcard-container"></div>
</template>

<script>
import $ from "jquery";
export default {
  name: "credit-card-widget",
  props: ["locationApiKey", "locationMid", "locationTid"],
  data() {
    return {
      card: {},
    };
  },
  methods: {
    SaveCreditCardSuccess(response) {
      // this.$vs.notify({
      //   time: 4000,
      //   title: "Success",
      //   text: "La información de la tarjeta de crédito guardada correctamente.",
      //   color: "success",
      //   iconPack: "feather",
      //   icon: "icon-check",
      //   position: "top-right",
      // });
      // const value = $("#response_html").val();

      response["TokenDetails"].card_type = this.cardType(
        $("#card-ui-component-txt-creditcard-number").val()
      );
      response["TokenDetails"].exp_month = +$(
        "#card-ui-component-ddl-expiry-month"
      ).val();
      response["TokenDetails"].exp_year = +$(
        "#card-ui-component-ddl-expiry-year"
      ).val();
      response["TokenDetails"].c_number = +$(
        "#card-ui-component-txt-creditcard-number"
      ).val();
      // console.log(response);
      this.$emit("SaveCreditCardSuccess", response);
      this.card = response;
    },
    SaveCreditCardFailure(response) {
      // this.$vs.notify({
      //   time: 4000,
      //   title: "Error",
      //   text: "La información de la tarjeta de crédito no pudo ser guardada.",
      //   color: "danger",
      //   iconPack: "feather",
      //   icon: "icon-alert-circle",
      //   position: "top-right",
      // });
      console.log(response);
    },
    cardType(cardType) {
      const number = cardType;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp("^62");
      if (number.match(re) != null) return "unionpay";

      re = new RegExp("^9792");
      if (number.match(re) != null) return "troy";

      re = new RegExp("^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}");
      if (number.match(re) != null) return "dinersclub";

      re = new RegExp("^35(2[89]|[3-8])");
      if (number.match(re) != null) return "jcb";

      return ""; // default type
    },
  },

  mounted() {
    const instance = this;
    $(document).ready(function () {
      $.ajax({
        type: "GET",
        url: process.env.VUE_APP_API_COMPONENT,
        data: {
          Token: "",
          Culture: "es",
          APIKey: instance.locationApiKey,
          terminalName: instance.locationTid,
          merchantAccountNumber: instance.locationMid,
        },
        success: function (response) {
          $("#creditcard-container").html(response);
          $("#cardImage").hide();

          $("#card-ui-component-ddl-expiry-month").css("width", "35%");
          $("#card-ui-component-ddl-expiry-year").css("width", "35%");

          // CSS CARD WIDGET
          $(".card-ui-component-outer").css("width", "100%");
          $(".card-ui-component-row-static").css("display", "grid");
          $(".card-ui-component-input-style").css("width", "100%");
          $(".card-ui-component-label-style").css("font-weight", "100");
          $(".card-ui-component-label-style").css("width", "100%");
          $(".card-ui-component-label-style").css("font-size", "0.85rem");
          $(".card-ui-component-card-bg").css("display", "none");
          //rename the close button to cancel
          //$(".card-ui-component-card-bg").css("position", "absolute");

          // FUNCTIONS
          window.SaveCreditCard_SuccessCallback = function (response) {
            instance.SaveCreditCardSuccess(response);
          };
          window.SaveCreditCard_FailureCallback = function (response) {
            instance.SaveCreditCardFailure(response);
          };

          window.SaveCreditCard_CancelCallback = function () {
            //mount again the widget
            $.ajax({
              type: "GET",
              url: process.env.VUE_APP_API_COMPONENT,
              data: {
                Token: "",
                Culture: "es",
                APIKey: instance.locationApiKey,
                terminalName: instance.locationTid,
                merchantAccountNumber: instance.locationMid,
              },
              success: function (response) {
                $("#creditcard-container").html(response);
                $("#cardImage").hide();

                $("#card-ui-component-ddl-expiry-month").css("width", "35%");
                $("#card-ui-component-ddl-expiry-year").css("width", "35%");

                // CSS CARD WIDGET
                $(".card-ui-component-outer").css("width", "100%");
                $(".card-ui-component-row-static").css("display", "grid");
                $(".card-ui-component-input-style").css("width", "100%");
                $(".card-ui-component-label-style").css("font-weight", "100");
                $(".card-ui-component-label-style").css("width", "100%");
                $(".card-ui-component-label-style").css("font-size", "0.85rem");
                $(".card-ui-component-card-bg").css("display", "none");
                //$(".card-ui-component-card-bg").css("position", "absolute");
              },
            });
          };
        },
        //handle ajax error
        error: function (xhr, textStatus, error) {
          console.log(xhr.statusText);
          console.log(textStatus);
          console.log(error);
        },
      });
    });
  },
  watch: {},
};
</script>

<style scoped lang="scss"></style>
